import { Link } from 'react-router-dom';

export default function BrowserPluginPage() {
  const environment = window.location.hostname === 'test-agent.huobanniu.top' ? '测试服' : '当前服务';
  return (
    <main className="mx-auto max-w-2xl space-y-6 px-6 py-12 text-stone-800">
      <Link className="text-sm underline" to="/">返回首页</Link>
      <h1 className="text-3xl font-semibold">浏览器金箍 · {environment}</h1>
      <p>在 Chrome 或兼容 Chromium 的浏览器安装插件，登录本服务账号后，即可连接浏览器 Agent。</p>
      <a className="inline-flex rounded-lg bg-stone-900 px-5 py-3 text-white" href="/browser-plugin/download" download>
        下载插件 ZIP
      </a>
      <ol className="list-decimal space-y-3 pl-6">
        <li>下载后解压 ZIP，保留包含 manifest.json 的完整文件夹。</li>
        <li>打开 chrome://extensions，开启「开发者模式」，点击「加载已解压的扩展程序」，选择该文件夹。</li>
        <li>点击插件图标打开侧栏，选择「登录并连接」，在本服务页面登录并确认授权。</li>
        <li>侧栏显示账号和「已连接」后，点击「检查连接」。检查通过后即可发送任务。</li>
      </ol>
      <p className="text-sm text-stone-600">测试服安装包固定连接测试服。检查连接会读取服务检查页面，不调用模型；执行 Agent 任务会按账号权限与积分计费。</p>
      <p className="text-sm text-stone-600">首次安装或版本更新需要重新加载插件。若下载返回 404，当前服务尚未发布安装包。</p>
    </main>
  );
}
